import React from 'react';
import PropTypes from 'prop-types';
import AreaList from './AreaList';
import AreaForm from './AreaForm';
import Message from 'rc-message';
import { create, deleteOne, getList } from 'api/areaApi';

class AreaManagement extends React.Component {
  static propTypes = {
    speciesID: PropTypes.string,
  };

  onCreate = async (values) => {
    const { speciesID } = this.props;
    const params = {
      ...values,
      SpeciesID: speciesID,
    }
    const res = await create(params);
    if (res.success) {
      Message.success({ content: 'Tạo Thành Công' });
      this.areaRef.fetData()
    }
    if (res.error) Message.error({ content: res.message });
  };

  onDelete = async (id) => deleteOne(id);

  setRef = (ref) => {
    this.areaRef = ref
  }

  render() {
    const { speciesID } = this.props
    return (
      <div>
        <AreaForm handleSubmit={this.onCreate} />
        <AreaList
          ref={this.setRef}
          handleDelete={this.onDelete}
          getListFunc={(query) => {
            return getList({
              ...query,
              SpeciesID: speciesID
            });
          }}
          onDelete={this.onDelete}
        />
      </div>
    );
  }
}

export default AreaManagement;



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/BiodiversityView/SpeciesManagement/AreaManagement/index.js